import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

import { Chip } from '@zippeditoolsjs/ui-web';

const FACTOR_COPY = {
  totp: {
    titleKey: 'heimdal_app.TOTP.also_add_totp_title',
    hintKey: 'heimdal_app.TOTP.also_add_totp_hint',
    badgeKey: 'heimdal_app.TOTP.recommended',
    badgeTone: 'success',
  },
  sms: {
    titleKey: 'heimdal_app.TOTP.also_add_sms_title',
    hintKey: 'heimdal_app.TOTP.also_add_sms_hint',
    badgeKey: 'heimdal_app.TOTP.optional_badge',
    badgeTone: 'muted',
  },
};

export default function AddSecondFactorOptIn({
  factor,
  checked,
  onToggle,
  disabled,
}) {
  const { t } = useTranslation();
  const copy = FACTOR_COPY[factor];

  return (
    <>
      <div className="my-3.5 h-px bg-muted" />
      <label
        className={`mb-4 flex cursor-pointer items-center gap-3 rounded-xl border border-solid bg-surface p-3.5 transition-[border-color] ${
          checked
            ? 'border-accent-tint'
            : 'border-muted hover:border-accent-tint'
        } ${disabled ? 'pointer-events-none opacity-60' : ''}`}>
        <input
          type="checkbox"
          className="peer sr-only"
          checked={checked}
          disabled={disabled}
          onChange={event => onToggle(event.target.checked)}
        />
        <span
          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-[7px] border border-solid transition-colors peer-focus-visible:shadow-[0_0_0_3px_var(--zippedi-accent-tint)] ${
            checked ? 'border-transparent bg-accent' : 'border-muted bg-surface'
          }`}>
          {checked ? (
            <IconComponent
              iconName="checkmark"
              style={{ fontSize: 14, color: 'var(--zippedi-text-on-dark-primary)' }}
            />
          ) : null}
        </span>
        <span className="flex flex-col gap-1">
          <span className="flex items-center gap-2">
            <span className="font-sans text-sm font-bold text-primary">
              {t(copy.titleKey)}
            </span>
            <Chip tone={copy.badgeTone}>{t(copy.badgeKey)}</Chip>
          </span>
          <span className="font-sans text-xs text-muted">
            {t(copy.hintKey)}
          </span>
        </span>
      </label>
    </>
  );
}

AddSecondFactorOptIn.propTypes = {
  factor: PropTypes.oneOf(['totp', 'sms']).isRequired,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
